import { get, postJSON, del, post } from '../utils/axios'

// 营业报表
interface businessReportProps {
    page?: string | number //当前页
    size?: string | number //每页大小
    startTime?: string //开始时间
    endTime?: string //截止时间
    queryStatus?: string //查询状态：0-开卡 1-充值 2-消费 3-过期 4-即将过期
}
export const businessReport = (options:businessReportProps) => postJSON('report/businessReport', options)

//营业额分析统计
export const businessAnalysis = (options:businessReportProps) => postJSON('report/businessAnalysis', options)

//营业额统计-服务明细列表
export const serviceCategoryStatisticList = (options:businessReportProps) => postJSON('report/serviceCategoryStatisticList', options)

//营业额统计-商品明细列表
export const productCategoryStatisticList = (options:businessReportProps) => postJSON('report/productCategoryStatisticList', options)

//收入图表数据列表
interface incomeChartDataProps {
    startTime?: string //开始时间
    endTime?: string //截止时间
    type?: string //日期类型0-按天 1-按月 2-按年
    queryType?: string //查询类型0-收入 1-支出
}
export const incomeChartData = (options:incomeChartDataProps) => postJSON('report/incomeChartData', options)

//支出图表数据列表
export const expenseChartData = (options:incomeChartDataProps) => postJSON('report/expenseChartData', options)

//出纳账户初始余额列表
interface selectAccountInitBalanceListProps {
    startTime?: string //开始时间
    endTime?: string //截止时间
}
export const selectAccountInitBalanceList = (options:selectAccountInitBalanceListProps) => postJSON('report/selectAccountInitBalanceList', options)

//出纳账户结余列表
export const cashierAccountList = (options:selectAccountInitBalanceListProps) => postJSON('report/cashierAccountList', options)

//出纳账户收支明细列表
interface selectAccountIncomeExpenseDetailListProps {
    orgPk?: string //门店pk
    page?: string //当前页
    cashierAccountPk?: string //出纳账户PK
    size?: string //每页大小
    type?: string //类型 0-收入 1-支出
    businessType?: string //业务类型PK
    inOrOutObjEctName?: string //交易对象
    actualStartAmount?: string //收支开始金额
    actualEndAmount?: string //收支结束金额
    remark?: string //备注
    startTime?: string //开始日期
    endTime?: string //截止日期
}
export const selectAccountIncomeExpenseDetailList = (options:selectAccountIncomeExpenseDetailListProps) => postJSON('report/selectAccountIncomeExpenseDetailList', options)

//采购付款记录列表
interface selectPurchasePayRecordListProps {
    page?: string //当前页
    size?: string //每页大小
    startTime?: string //开始时间
    endTime?: string //截止时间
}
export const selectPurchasePayRecordList = (options:selectPurchasePayRecordListProps) => postJSON('report/selectPurchasePayRecordList', options)

//其他支出记录列表
export const selectOtherExpensesRecordList = (options:selectPurchasePayRecordListProps) => postJSON('report/selectOtherExpensesRecordList', options)

//主营业额实际收款记录列表
interface selectReceiveCarActualPaymentRecordListProps {
    page?: string //当前页
    size?: string //每页大小
    startTime?: string //开始时间
    endTime?: string //截止时间
}
export const selectReceiveCarActualPaymentRecordList = (options:selectReceiveCarActualPaymentRecordListProps) => postJSON('report/selectReceiveCarActualPaymentRecordList', options)

//主营业额挂账收款记录列表
export const selectReceiveCarCreditReceiveRecordList = (options:selectReceiveCarActualPaymentRecordListProps) => postJSON('report/selectReceiveCarCreditReceiveRecordList', options)

//预收-定金预收记录列表
export const selectDepositPrePaymentRecordList = (options:selectReceiveCarActualPaymentRecordListProps) => postJSON('report/selectDepositPrePaymentRecordList', options)

//预收-会员卡预收记录列表
export const selectMemberCardPrePaymentRecordListt = (options:selectReceiveCarActualPaymentRecordListProps) => postJSON('report/selectMemberCardPrePaymentRecordList', options)

//预收-活动预收记录列表
export const selectActivityParticipationRecordList = (options:selectReceiveCarActualPaymentRecordListProps) => postJSON('report/selectActivityParticipationRecordList', options)

//其他收入记录列表
export const selectOtherIncomeRecordList = (options:selectReceiveCarActualPaymentRecordListProps) => postJSON('report/selectOtherIncomeRecordList', options)

//工单列表
interface selectReceiveCarListProps {
    page?: string //当前页
    size?: string //每页大小
    startTime?: string //开始时间
    endTime?: string //截止时间
    subTypePk?: string
}
export const selectReceiveCarList = (options:selectReceiveCarListProps) => postJSON('report/selectReceiveCarList', options)

//采购单详情
export const selectPurchaseBillByCode = (purchaseBillCode:string) => postJSON('report/selectPurchaseBillByCode', { purchaseBillCode })

//会员卡开卡详情
export const selectOpenCardDetailByCardPk = (cardPk:string) => post('userCard/selectOpenCardDetailByCardPk', { cardPk })

//预收头部统计
export const advancePaymentHeadStatistics = (options:any) => postJSON('report/advancePaymentHeadStatistics', options)

